import { Location } from "@hydrologiq/gql/graphql"
import { createSlice } from "@reduxjs/toolkit"
import { PayloadAction } from "@reduxjs/toolkit"

interface LocationsState {
  value: Location[] | undefined
}

const initialState = { value: undefined } satisfies LocationsState as LocationsState

export const locationsSlice = createSlice({
  name: "locations",
  initialState,
  selectors: {
    getLocations: (state): Location[] => {
      return state.value || []
    },
    getLocation: (state, id?: string): Location | undefined => {
      return id ? state.value?.find((location) => location.id === id) : undefined
    },
  },
  reducers: {
    updateLocation: (state, action: PayloadAction<Location>) => {
      state.value = state.value?.map((location) => (location.id === action.payload.id ? action.payload : location))
    },
    addLocation: (state, action: PayloadAction<Location>) => {
      state.value = [action.payload, ...(state.value || [])]
    },
    setLocations: (state, action: PayloadAction<Location[]>) => {
      state.value = action.payload
    },
  },
})

export const { updateLocation, setLocations, addLocation } = locationsSlice.actions
export const { getLocations, getLocation } = locationsSlice.selectors
export default locationsSlice.reducer
